import React from "react";
import { useTranslation } from "react-i18next";

import "./ConsultationDialog.css";

interface ConsultationDialogProps {
  title: string;
  message: string;
  isOpen: boolean;
  onClose: () => void;
  showProgress?: boolean;
  type?: "alert" | "confirm";
  onConfirm?: () => void;
}

const ConsultationDialog: React.FC<ConsultationDialogProps> = ({
  title,
  message,
  isOpen,
  onClose,
  showProgress = false,
  type = "alert",
  onConfirm,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="comp-modal">
      <div className="modal-wrapper">
        <div className="modal-container">
          <div className="modal-header">
            <div className="title">{title}</div>
            <div
              className="btn btn-sub btn-text btn-compact btn-small"
              onClick={onClose}
            >
              <span>{t("close")}</span>
            </div>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          {showProgress ? (
            <div className="modal-footer has-divider">
              <div className="progress-container">
                <div className="progress-bar"></div>
              </div>
            </div>
          ) : type === "confirm" ? (
            <div className="modal-footer">
              <div className="form-wrapper evenly btn-small">
                <div className="form-container">
                  <div className="btn btn-line" onClick={onClose}>
                    <span>{t("cancel")}</span>
                  </div>
                  <div className="btn" onClick={onConfirm}>
                    <span>{t("confirm")}</span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="modal-footer">
              <div className="form-wrapper evenly btn-small">
                <div className="form-container">
                  <div className="btn" onClick={onClose}>
                    <span>{t("confirm")}</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConsultationDialog;
